// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\EventsSection\\\\EventsSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\EventsSection\\EventsSection.tsx");
  import.meta.hot.lastModified = "1759351316845.4817";
}
// REMIX HMR END

import { SectionHeader } from "~/components/shared/SectionHeader";
import { EventsGrid } from "~/components/shared/EventsGrid";
export function EventsSection({
  title,
  data
}) {
  return <section className="relative w-full bg-white">
      <div className="mx-auto w-full max-w-[1328px] px-4 lg:px-14 py-14 lg:py-24">
        <SectionHeader title={title} className="mb-4" />
        <EventsGrid data={data} />
      </div>
    </section>;
}
_c = EventsSection;
var _c;
$RefreshReg$(_c, "EventsSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;